import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  CompanyUserData,
  useCompanyUsers,
} from '../../../../../../services/api/companies'
import { AsyncStates } from '../../../../../../components'
import { View } from './View'
import { defaultPagination } from '../../../../../../services/api/client/types'

export const Container: React.FunctionComponent = () => {
  const { id } = useParams()
  const [getCompanyUsers, { isLoading, response, error }] = useCompanyUsers(id)

  useEffect(() => {
    getCompanyUsers(defaultPagination)
  }, [getCompanyUsers])

  return (
    <AsyncStates<CompanyUserData[]>
      inline
      isLoading={isLoading}
      error={error}
      errorMessage="Не удалось загрузить администраторов"
      reload={() => getCompanyUsers(defaultPagination)}
      response={response}
      renderData={(users) => <View users={users} />}
    />
  )
}
